export default "__VITE_ASSET__BJs0myyb__"